export default "__VITE_ASSET__inb8mExl__"